import { PageHeader } from "@/components/common";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const submit = (e) => {
    e.preventDefault();
    toast.success("Thanks! We'll get back to you soon.");
    e.target.reset();
  };
  return (
    <div data-testid="contact-page">
      <PageHeader caption="Get In Touch" title="Contact" subtitle="Questions about an event, bookings or partnerships? Reach out." />
      <div className="mx-auto grid max-w-5xl gap-8 px-4 pb-10 sm:px-8 lg:grid-cols-2">
        <div className="space-y-4">
          <Info icon={Mail} label="Email" value="hello@sirakhcreations.com" />
          <Info icon={Phone} label="Phone" value="+91 00000 00000" />
          <Info icon={MapPin} label="Location" value="Mumbai, India" />
          <Info icon={Instagram} label="Instagram" value="@sirakhcreations" />
        </div>
        <form onSubmit={submit} className="card-dark p-6 sm:p-8" data-testid="contact-form">
          <div className="space-y-4">
            <div>
              <label className="caption mb-2 block">Name</label>
              <input className="input-field" required data-testid="contact-name" />
            </div>
            <div>
              <label className="caption mb-2 block">Email</label>
              <input type="email" className="input-field" required data-testid="contact-email" />
            </div>
            <div>
              <label className="caption mb-2 block">Message</label>
              <textarea rows={4} className="input-field" required data-testid="contact-message" />
            </div>
            <button type="submit" className="btn-gold w-full" data-testid="contact-submit">SEND MESSAGE</button>
          </div>
        </form>
      </div>
    </div>
  );
}

const Info = ({ icon: Icon, label, value }) => (
  <div className="card-dark flex items-center gap-4 p-5">
    <div className="flex h-11 w-11 items-center justify-center rounded-md bg-[#D4AF37]/15 text-[#D4AF37]"><Icon size={20} /></div>
    <div>
      <p className="text-xs uppercase tracking-wider text-zinc-500">{label}</p>
      <p className="font-medium text-white">{value}</p>
    </div>
  </div>
);
